/* eslint-disable max-len */
import Dispatchers from '@/mixins/dispatchers';
const BastanteoItem = () => import(/* webpackChunkName: 'BastanteoItem' */ '@/views/shared/bastanteo/bastanteo-item');

export default {
    name: 'BastanteoGroup',

    mixins: [Dispatchers],

    components: {
        BastanteoItem
    },

    /**
     * @override
     */
    data() {
        return {
            opened: true,
            documentListArray: {
                name: '',
                items: []
            },
            docsPending: 0
        };
    },
    props: {
        type: {
            type: String,
            required: true
        },
        uuid: {
            type: String,
            required: false
        },
        intervener: {
            type: Object,
            required: false
        },
        account: {
            type: Object,
            required: false
        },
        operation: {
            type: Object,
            required: false
        },
        itemActive: {
            type: Object,
            required: false
        },
        justInfo: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    /**
     * @override
     */
    created() {
        this.fetchData();
    },
    mounted() {
        this.$root.$on('refresh_bastanteo_groups', this.fetchData);
    },
    beforeDestroy() {
        this.$root.$off('refresh_bastanteo_groups', this.fetchData);
    },
    computed: {
        /**
         * Documentos a listar en el árbol, ocultando los vídeos de anverso/reverso
         * de Finveris (se abren desde el icono de vídeo de su imagen asociada)
         * @return {Array} items visibles
         */
        visibleDocumentItems() {
            return this.documentListArray.items.filter(
                x => !['VIDEO_IDENTIFICATIVO_PF_ANVERSO', 'VIDEO_IDENTIFICATIVO_PF_REVERSO'].includes(x.key_subcategory)
            );
        }
    },

    methods: {
        /**
         * Busca el vídeo de Finveris asociado a una imagen de anverso/reverso
         * @param {Object} item imagen de anverso o reverso
         * @return {Object|null} documento de vídeo asociado, si existe
         */
        findVideoSibling(item) {
            const videoSubcategoryByImage = {
                DOCUMENTO_IDENTIFICATIVO_PF_ANVERSO: 'VIDEO_IDENTIFICATIVO_PF_ANVERSO',
                DOCUMENTO_IDENTIFICATIVO_PF_REVERSO: 'VIDEO_IDENTIFICATIVO_PF_REVERSO'
            };
            const videoSubcategory = videoSubcategoryByImage[item.key_subcategory];
            if (!videoSubcategory) {
                return null;
            }
            return (
                this.documentListArray.items.find(x => x.key_subcategory === videoSubcategory && x.uuid) || null
            );
        },

        /**
         * Muestra documento en ventana flotante
         * @param {Object} item documento a mostrar
         */
        showDocumentInWindow(item) {
            if (item.key_subcategory === 'VIDEOIDENTIFICACION' && item.is_validated) {
                this.$toast.warning('Aviso', 'Video identificación ya validada');
                return;
            }
            item.type = {
                type: this.type,
                uuid: this.uuid,
                is_validated: item.is_validated
            };
            item.has_finveris_account = this.intervener?.personal_data?.has_finveris_account ?? false;
            this.$store.dispatch('bastanteoStore/setNewFloatWindow', item);
        },

        /**
         * Carga los datos (lista de documentos)
         */
        fetchData() {
            if (this.type === 'account') {
                this.$accountsService
                    .getAccountDocumentsValidations(this.uuid)
                    .then(res => {
                        this.documentListArray = {
                            name: `Cuenta ${this.account.id_object}`
                        };

                        this.documentListArray.items = res.data.accounts_documents.filter(x => {
                            return (
                                x.key_category !== 'OTHERS' &&
                                x.key_subcategory !== 'DOCUMENTO_ACREDITATIVO_TITULARIDAD_CC' &&
                                x.key_subcategory !== 'NO_INNOCAPITAL_RAW_DOCUMENTATION' &&
                                x.key_subcategory !== 'EEPP' &&
                                x.key_subcategory !== 'IIGG' &&
                                x.key_subcategory !== 'IIFF' &&
                                x.key_subcategory !== 'TEST_KYC_ASOCIADO_PATRONO'
                            );
                        });

                        const associatesPatronsDocs = res.data.accounts_documents
                            .filter(x => {
                                return ( x.key_subcategory === 'TEST_KYC_ASOCIADO_PATRONO');
                            })
                        this.$root.$emit('emit_add_associates_patrons_docs', associatesPatronsDocs);

                        // Sacamos lo documentos de la categoría otros de cuenta solo si estamos en la vista de una cuenta
                        // De forma que cuando estemos en una operación, no salgan
                        if (this.$route.name === 'accounts_uuid' || this.$route.name === 'accounts_uuid_view') {
                            const othersDocs = res.data.accounts_documents
                                .filter(x => {
                                    return (
                                        x.key_category === 'OTHERS' ||
                                        x.key_subcategory === 'NO_INNOCAPITAL_RAW_DOCUMENTATION'
                                    );
                                })
                                .map(x => ({
                                    type: 'account',
                                    uuid: this.account.uuid,
                                    data: x
                                }));
                            this.$root.$emit('emit_add_others_doc', othersDocs);
                        }

                        const bankDocs = res.data.accounts_documents
                            .filter(x => x.key_subcategory === 'DOCUMENTO_ACREDITATIVO_TITULARIDAD_CC')
                            .map(x => ({
                                type: 'account',
                                uuid: this.account.uuid,
                                data: x
                            }));
                        this.$root.$emit('emit_add_bank_account_docs', bankDocs);

                        this.countTotalItemsPending();
                    })
                    .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
            } else if (this.type === 'interveners') {
                this.$intervenersService
                    .getIntervenerDocumentsValidations(this.uuid)
                    .then(async res => {
                        if (this.intervener.personal_data) {
                            this.documentListArray.name += this.intervener.personal_data.name
                                ? `${this.intervener.personal_data.name}`
                                : '';
                            this.documentListArray.name += this.intervener.personal_data.lastname_1
                                ? ` ${this.intervener.personal_data.lastname_1}`
                                : '';
                            this.documentListArray.name += this.intervener.personal_data.lastname_2
                                ? ` ${this.intervener.personal_data.lastname_2}`
                                : '';
                            this.documentListArray.name = this.documentListArray.name.trim();
                        } else {
                            this.documentListArray.name += this.intervener.name ? `${this.intervener.name}` : '';
                            this.documentListArray.name += this.intervener.lastname_1
                                ? ` ${this.intervener.lastname_1}`
                                : '';
                            this.documentListArray.name += this.intervener.lastname_2
                                ? ` ${this.intervener.lastname_2}`
                                : '';
                            this.documentListArray.name = this.documentListArray.name.trim();
                        }

                        this.documentListArray.items = res.data.interveners_documents.filter(x => {
                            return (
                                x.key_category !== 'OTHERS' && x.key_subcategory !== 'NO_INNOCAPITAL_RAW_DOCUMENTATION'
                            );
                        });
                        this.documentListArray.items = await this.filterNullKycTest(this.documentListArray.items);

                        // Sacamos los documentos de la categoría otros de interviniente solo si estamos en la vista de un interviniente
                        // De forma que cuando estemos en una cuenta o en una operación, no salgan
                        if (this.$route.name === 'interveners_uuid' || this.$route.name === 'interveners_uuid_view') {
                            const othersDocs = res.data.interveners_documents
                                .filter(x => {
                                    return (
                                        x.key_category === 'OTHERS' ||
                                        x.key_subcategory === 'NO_INNOCAPITAL_RAW_DOCUMENTATION'
                                    );
                                })
                                .map(x => ({
                                    type: 'intervener',
                                    uuid: this.intervener.uuid,
                                    data: x
                                }));
                            this.$root.$emit('emit_add_others_doc', othersDocs);
                        }
                        this.countTotalItemsPending();
                    })
                    .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
            } else {
                this.$operationsService
                    .getDocumentsValidations(this.operation.operation_id)
                    .then(res => {
                        const operationOthersDocs = res.data.operation_documents
                            .filter(x => x.key_category === 'OTHERS')
                            .map(x => ({
                                type: 'operation',
                                uuid: this.operation.operation_id,
                                data: x
                            }));
                        this.$root.$emit('emit_add_others_doc', operationOthersDocs);
                        this.documentListArray = {
                            name: 'Operación',
                            items: res.data.operation_documents.filter(x => {
                                return x.key_category !== 'OTHERS';
                            })
                        };
                        this.countTotalItemsPending();
                    })
                    .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
            }
        },

        /**
         * Cuenta el total de items pendientes (requeridos y no validados)
         * Emite el resultado que es recibido por el componente padre del bastanteo
         * Este método se lanza cuano se hace el fetchData
         */
        countTotalItemsPending() {
            const docsPendingRequired = this.documentListArray.items.filter(
                x => x.is_required === true && (!x.is_validated || x.is_validated === null)
            );
            this.docsPending = docsPendingRequired.length;
            this.$root.$emit('emit_items_not_validated', docsPendingRequired);
        },

        /**
         * @param {*} documentList Array con los documentos del interviniente
         * @return {*} Array filtrado sin el KYC en caso de que se requiera
         */
        async filterNullKycTest(documentList) {
            try {
                const kycTest = documentList.find(
                    doc => doc.key_subcategory === 'CUESTIONARIO_CONOCIMIENTO_PERSONA_FISICA'
                );
                const intervenerAccounts = await this.$intervenersService.getIntervenerParticipantAccounts(
                    this.uuid,
                    {}
                );
                const notCobasAccount = !!intervenerAccounts.data.intervener_accounts.find(account => {
                    return account.distributor_data.key_name !== 'INNOCAPITAL';
                });

                if (kycTest && !kycTest.uuid && !kycTest.title && notCobasAccount) {
                    return documentList.filter(
                        doc => !(doc.key_subcategory === 'CUESTIONARIO_CONOCIMIENTO_PERSONA_FISICA' && !doc.uuid)
                    );
                }
                return documentList;
            } catch (err) {
                console.error(err);
            }
        }
    }
};
